(function ($) {
    'use strict';

    var fieldContainers = document.querySelectorAll('[data-tenant-address]');

    if (!fieldContainers) {
        return false;
    }

    // Loop through the fields set and check only the second and +
    for (var x = 0; x < fieldContainers.length; x++) {
        if (x === 0) {
            continue;
        }

        var fieldContainer = fieldContainers[x];

        // Get all the inputs and select from the container
        var fields = fieldContainer.querySelectorAll('input, select');

        for (var y = 0; y < fields.length; y++) {
            var field = fields[y];

            // Bind a change event on the fields
            field.addEventListener('change', onFieldChange);
        }

        checkFieldsValue($(fieldContainer));
    }

    var $body = $('body');

    $body.on('autocomplete-address.place-changed', function (_, $container) {
        checkFieldsValue($container);
    });

    // toggle required status via checkbox
    var checkboxTriggers = $('[data-disabled-trigger]');

    checkboxTriggers.each(function() {
        $(this).change(function() {
            var value = this.dataset.disabledTrigger;
            var target = document.querySelectorAll('[data-disabled-target= ' + value + ']');
            var container = $(target).parent('.form-group');
            toggleRequiredFields(target, !target[0].hasAttribute('required'), container);

            // for apartment number, field is disabled
            if(value.indexOf('apartment') !== -1) {
                toggleDisabledFields(target, !target[0].hasAttribute('disabled'), container);
            }
        })

        // at loading, for apartment only, check if field must be disabled
        var value = $(this).data('disabled-trigger');

        if(value.indexOf('apartment') !== -1) {
            var target = document.querySelectorAll('[data-disabled-target= ' + value + ']');
            var container = $(target).parent('.form-group');
            if($(this)[0].checked) {
                container.find('.text-danger').hide();
                toggleDisabledFields(target, !target[0].hasAttribute('disabled'), container);
            }
        }
    })

    function onFieldChange() {
        var el = this;
        var $container = $(el).closest('[data-tenant-address]');

        //  Check fields values method
        var isBlank = checkFieldsValue($container);

        if (isBlank) return;

        var $international = $('#international-addresses-' + x);
        var $countrySelect = $container.find('#tenant_addresses_'+ x +'_country');
        var $stateSelect = $container.find('#tenant_addresses_'+ x +'_state');

        if (!$countrySelect && !$stateSelect && !$international) {
            console.log('No country, state and international checkbox found');
            return;
        }

        if ($stateSelect.val() === '' && $countrySelect.val() === '' && !$international.is(':checked')) {
            $countrySelect.val('CA');
        }
    }


    // Method to check if the fields contain a value
    function checkFieldsValue(el) {
        // Get the fields that have the data-required attribute in the nodelist of the retrieved container el in params
        var fields = el.find('input, select').filter('[data-required]');
        var isBlank = true;

        // Loop throught the fields
        fields.each(function() {
            var field = $(this);
            var value = field.val();

            // Check if field should be checked (exemple: Select fields are not checked because they can have default value)
            if(!field[0].hasAttribute('data-no-empty')) {
                // If any fields value is not empty, that means a field was filled,
                // then we return false and set all data-required fields with required attribute;
                if (value !== '' || field.is(':checked')) {
                    isBlank = false;
                    toggleRequiredFields(fields, true, el);
                    return false;
                // If all fields values are empty, that means the fields are all blank
                // and remove all required attributes from data-required fields
                } else {
                    toggleRequiredFields(fields, false, el);
                    isBlank = true;
                }
            }
        });

        // Return the status;
        return isBlank;
    }

    // Method toggleRequiredFields
    // Param 1 : input and select fields
    // Param 2 : Boolean that indicate if the fields need to be set required or not
    // Param 3 : The container of the fields

    function toggleRequiredFields(fields, isRequired, container) {
        $(fields).each(function () {
            var field = $(this);

            // Check if the field need to be required and show the little red dot, if not remove required attribute.
            if (isRequired) {
                field.prop('required', true);
                container.find('.text-danger').show();
            } else {
                field.removeAttr('required');
                container.find('.text-danger').hide();
            }
        });
    }

    // Method toggleDisabledFields
    // Param 1 : input and select fields
    // Param 2 : Boolean that indicate if the fields need to be set disabled or not
    // Param 3 : The container of the fields

    function toggleDisabledFields(fields, isDisabled, container) {
        $(fields).each(function () {
            var field = $(this);

            // Check if the field need to be required and show the little red dot, if not remove required attribute.
            if (isDisabled) {
                field.val('');
                field.prop('disabled', true);
                field.prop('required', false);
                container.removeClass('is-filled');
            } else {
                field.removeAttr('disabled');
                field.prop('required', true);
            }
        });
    }
})(require('jquery'));
